import React, { RefObject } from 'react';
import { Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroller';

import CommentCard from './CommentCard';
import { MemberCommentViewModel } from 'api/adminApiClient';
import style from './CommentsList.module.less';
import { SubmitComment } from '../CommentInput/CommentInput';

type Props = {
  comments: MemberCommentViewModel[];
  onLoadMore: (page: number) => void;
  hasMore: boolean;
  scrollRef: RefObject<HTMLElement>;
  infiniteScrollRef: any;
  onSubmit: (data: SubmitComment) => Promise<boolean | undefined>;
};

export default React.memo((props: Props) => {
  const {
    comments,
    onLoadMore,
    hasMore,
    scrollRef,
    infiniteScrollRef,
    onSubmit,
  } = props;

  return (
    <InfiniteScroll
      pageStart={-1}
      loadMore={onLoadMore}
      hasMore={hasMore}
      loader={<Spin key={0} />}
      useWindow={false}
      getScrollParent={() => scrollRef.current}
      ref={infiniteScrollRef}
    >
      {comments.map((comment) => (
        <div key={comment.id} className={style.commentItem}>
          <CommentCard comment={comment} onSubmit={onSubmit} />
        </div>
      ))}
    </InfiniteScroll>
  );
});
